import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'translations/i18n';
import Modal from 'components/shared/DesignSystem/Modal';
import styled from 'styled-components';
import { Button } from '@companycam/slab-web';

const StyledModal = styled(Modal)`
  height: 354px;
  width: 450px;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: space-between;
`;

const ErrorIcon = styled.i`
  font-size: 85px;
  color: var(--cc_color_utility_destroy);
`;

const Msg = styled.p`
  font-weight: 700;
  font-size: var(--cc_size_text_l);
`;

const Description = styled.p`
  color: var(--cc_color_text_subtle);
`;

const ErrorModal = ({ isOpen, onRequestClose }) => {
  return (
    <StyledModal
      isOpen={isOpen}
      isClosable
      onRequestClose={onRequestClose}
      className="modal-content-wrap"
    >
      <ErrorIcon className="mdi mdi-alert" />
      <Msg>{translate('projects.taskList.exportPdf.errorMessage')}</Msg>
      <Description>
        {translate('projects.taskList.exportPdf.errorDescription')}
      </Description>

      <div className="btn-container">
        <Button onClick={onRequestClose}>{translate('common.cancel')}</Button>
      </div>
    </StyledModal>
  );
};

ErrorModal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
};

export default ErrorModal;
